import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';

import { filter } from 'rxjs/operators';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import {
   BreakpointService,
   BreadcrumbService,
   SearchService,
} from '@library/core/services';

@UntilDestroy()
@Component({
   selector: 'lib-activity-bar',
   templateUrl: './activity-bar.component.html',
   styleUrls: ['./activity-bar.component.scss'],
   animations: [
      trigger( 'slideIn', [
         transition( ':enter', [
            style({ width: 0, 'margin-left': 0 }),
            animate( '300ms ease-in-out', style({ width: '*', 'margin-left': '*' }))
         ]),
         transition( ':leave', [
            animate( '300ms ease-in-out', style({ width: 0, 'margin-left': 0 }))
         ]),
      ]),
   ],
})
export class ActivityBarComponent implements OnInit {

   searchHover = false;

   @ViewChild('searchInput') searchInput: ElementRef;

   constructor(
      public breadcrumbs: BreadcrumbService,
      public breakpoints: BreakpointService,
      public search: SearchService,
   ) { }

   ngOnInit() {
      this.search.searchActive$.pipe(
         filter( _ => this.search.showSearch ),
         filter( active => active ),
         untilDestroyed( this ),
      ).subscribe( _ => {
         this.searchHover = false;
         setTimeout( _ => this.searchInput && this.searchInput.nativeElement.focus(), 1 );
      });

      this.search.blurText.subscribe(( toBlur ) => {
         if ( toBlur ) {
            this.searchInput?.nativeElement.blur();
         }
      });
   }

   enterKeyUp() {
      this.search.enterKeyUp.next( true );
   }
}
